import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, MapPin, Mail, Facebook, Clock, Heart } from 'lucide-react';
import { businessInfo } from '../mockData';

const Footer = () => {
  return (
    <footer className="bg-black border-t border-neutral-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-10 h-10 bg-gradient-to-br from-white to-teal-500 rounded-lg flex items-center justify-center">
                <Phone className="w-6 h-6 text-white" />
              </div>
              <div>
                <h3 className="text-lg font-bold text-white">Evolution</h3>
                <p className="text-xs text-gray-400">Cell Phone Repairs</p>
              </div>
            </div>
            <p className="text-gray-400 text-sm mb-4">
              Fast, affordable, and reliable phone repairs in El Paso. We're here when you need us most.
            </p>
            <div className="flex items-center gap-2">
              <span className="px-3 py-1 bg-white/10 border border-white/20 rounded-full text-white text-xs font-medium">
                Latino-Owned
              </span>
              <span className="px-3 py-1 bg-pink-500/10 border border-pink-500/20 rounded-full text-pink-400 text-xs font-medium flex items-center gap-1">
                <Heart className="w-3 h-3" />
                LGBTQ+ Friendly
              </span>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-white font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-gray-400 hover:text-white transition-colors text-sm">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-gray-400 hover:text-white transition-colors text-sm">
                  Services
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-gray-400 hover:text-white transition-colors text-sm">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/reviews" className="text-gray-400 hover:text-white transition-colors text-sm">
                  Reviews
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-gray-400 hover:text-white transition-colors text-sm">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-white font-semibold mb-4">Popular Services</h4>
            <ul className="space-y-2 text-sm text-gray-400">
              <li>Screen Repair</li>
              <li>Battery Replacement</li>
              <li>iPhone & Android Repair</li>
              <li>Laptop Repair</li>
              <li>Computer Repair</li>
              <li>Game Console Repair</li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-white font-semibold mb-4">Contact Us</h4>
            <ul className="space-y-3">
              <li>
                <a 
                  href={`tel:${businessInfo.phone}`}
                  className="flex items-start gap-2 text-gray-400 hover:text-white transition-colors text-sm group"
                >
                  <Phone className="w-5 h-5 mt-0.5 flex-shrink-0 group-hover:text-white" />
                  <span>{businessInfo.phone}</span>
                </a>
              </li>
              <li>
                <a 
                  href={`mailto:${businessInfo.email}`}
                  className="flex items-start gap-2 text-gray-400 hover:text-white transition-colors text-sm group"
                >
                  <Mail className="w-5 h-5 mt-0.5 flex-shrink-0 group-hover:text-white" />
                  <span>{businessInfo.email}</span>
                </a>
              </li>
              <li>
                <a 
                  href={`https://maps.google.com/?q=${encodeURIComponent(businessInfo.address)}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-start gap-2 text-gray-400 hover:text-white transition-colors text-sm group"
                >
                  <MapPin className="w-5 h-5 mt-0.5 flex-shrink-0 group-hover:text-white" />
                  <span>{businessInfo.address}</span>
                </a>
              </li>
              <li className="flex items-start gap-2 text-gray-400 text-sm">
                <Clock className="w-5 h-5 mt-0.5 flex-shrink-0 text-white" />
                <div>
                  <p className="text-white font-medium">Open Daily</p>
                  <p>Closes at 2:00 AM</p>
                </div>
              </li>
            </ul>
            <div className="mt-4">
              <a
                href={businessInfo.facebook}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 text-gray-400 hover:text-white transition-colors"
              >
                <Facebook className="w-5 h-5" />
                <span className="text-sm">Follow us on Facebook</span>
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-8 border-t border-neutral-800">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-gray-500">
            <p>© 2024 Evolution Cell Phone Repairs. All rights reserved.</p>
            <p>
              Serving El Paso, TX with pride • Walk-ins Welcome
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
